export const primitive = {
  blue: {
    900: '#009BD0',
    700: '#1DB8F2',
    300: '#D3E5F4',
    200: '#E7EEF4',
    100: '#EFF4F9',
    50: '#F4FBFF'
  },
  gray: {
    900: '#0A1E28',
    700: '#364955',
    500: '#667A86',
    300: '#9AAEBB',
    200: '#B5C9D6',
    100: '#F2F2F2',
    0: '#FFFFFF'
  },
  green: {
    900: '#3F7A42',
    700: '#569E59',
    200: '#CCE6CD',
    100: '#EAF2EA'
  },
  red: {
    900: '#BA1B1B',
    700: '#DD3730',
    200: '#FFDAD4',
    100: '#FFEAE5'
  },
  orange: {
    900: '#E06500',
    700: '#ED6C02',
    200: '#FFD5AD',
    100: '#FFE9D4'
  },
  custom: {
    pink: '#F78DB3'
  }
} as const;
